module.exports = __webpack_public_path__ + "img/NoSearchResult.f4e42b39.png";